import type { HubMetricConfig } from "@expert/app-config";

import { Text } from "@mantine/core";

import styles from "./cardContent.module.css";
import { MetricCard } from "./MetricCard";
import { buildFooter, formatValue, resolveTone, unitSuffix } from "./metricFormat";

interface Props {
    config: HubMetricConfig;
    displayValue: number | null;
    isLoading: boolean;
    isError: boolean;
    isEmpty: boolean;
    emptyValue?: string;
    /** When false, suppress the status pill even with a target + value (e.g. in-progress live metrics). */
    grade?: boolean;
    onClick?: () => void;
}

export function ConfigMetricCard({
    config,
    displayValue,
    isLoading,
    isError,
    isEmpty,
    emptyValue,
    grade = true,
    onClick,
}: Props) {
    const { target, decimals } = config;
    const footer = buildFooter(target);
    const suffix = target ? unitSuffix(target.unit) : "";

    const graded = grade && target != null && displayValue !== null && !isEmpty && !isError;
    const { status, tone } = graded ? resolveTone(displayValue, target) : { status: undefined, tone: undefined };

    return (
        <MetricCard
            title={config.title}
            isLoading={isLoading}
            isError={isError}
            isEmpty={isEmpty}
            emptyValue={emptyValue ?? config.emptyText ?? "No recent data."}
            value={
                displayValue !== null ? (
                    <>
                        <Text component="span" className={styles.bigNumber}>
                            {formatValue(displayValue, decimals)}
                        </Text>
                        {suffix ? (
                            <Text component="span" className={styles.unit}>
                                {suffix}
                            </Text>
                        ) : null}
                    </>
                ) : null
            }
            footer={footer}
            status={status}
            tone={tone}
            onClick={onClick}
        />
    );
}
